<template>
  <div data-module="relatedWorks">
    <div class="heading">
      <h2 data-type="default">
        More Work
      </h2>
    </div>
    <div class="content">
      <template v-for="work in works">
        <div class="related-work" :key="work.slug">
          <h3 data-type="article-heading">
            {{work.blurb.headline}}
          </h3>
          <router-link v-bind:to="{ name: 'L3', params: { slug: work.slug, itemType: 'work' } }">
            {{work.blurb.byline}}
          </router-link>
        </div>
    </template>
    </div>
  </div>
</template>

<script>
import worksData from '@/content/work';

export default {
  name: 'module_relatedWorks',
  props: ['data'],
  computed: {
    works: function() {
      const works = [];
      this.data.works.forEach(function(work) {
        works.push(worksData[work]);
      });

      return works;
    },
  },
};
</script>

<style lang="scss">
@import '~@/styles/_variables.scss';
@import '~@/styles/_mixins.scss';
@import '~@/styles/_typography.scss';

[data-module="relatedWorks"] {
  @include grid($subgrid: true);

  .heading {
    grid-column: 1 / -1;
  }

  .content {
    grid-column: 1 / -1;
    @include grid();
  }

  @include mq($bp--tablet, up) {
    @include spacer();

    .related-work:nth-child(odd) {
      grid-column: 1 / span 5;
    }

    .related-work:nth-child(even) {
      grid-column: 7 / span 5;
    }
  }

  @include mq($bp--tablet, down) {
    .related-work {
      grid-column: 1 / -1;
    }

    .related-work:not(:last-child) {
      @include spacer($ratio: 0.5);
    }

    .related-work:last-child {
      @include spacer();
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/modules/relatedWorks.vue